"use client";

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTheme } from 'next-themes';
import { Button, Heading, Text } from '@/components/ui/design-system';

const CallToAction = () => {
  const { theme } = useTheme();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <section 
      className="relative w-full premium-gradient-primary py-12 md:py-0"
      aria-labelledby="cta-heading"
      role="region"
    >
      <div className="container relative mx-auto flex flex-col items-center justify-between px-6 md:px-8 lg:px-4 md:flex-row md:items-center">
        <div className="mb-8 text-center md:mb-0 md:text-left">
          <Heading 
            level={2} 
            id="cta-heading"
            className="text-3xl font-bold text-white md:text-4xl"
          >
            Unbox Excellence. Define Your Brand.
          </Heading>
          <Text className="mt-4 text-lg text-white/90 max-w-2xl">
            Discover bespoke packaging solutions that elevate your products and enchant your customers.
          </Text>
          <Link href="/contact" passHref>
            <Button 
              variant="secondary" 
              size="lg" 
              radius="full" 
              className="mt-6 px-8 py-3 text-lg font-semibold transition-all duration-300 hover:scale-105 focus:ring-2 focus:ring-white/50 focus:outline-none"
              aria-label="Contact us for pricing information"
            >
              Contact for Price
            </Button>
          </Link>
        </div>
                <div className="relative z-10 h-64 w-80 md:h-[32rem] md:w-[32rem] md:self-end md:translate-y-20 md:translate-x-12">
          <Image
            src="/images/pages/home/floating-product.png"
            alt="Premium packaging products showcasing our manufacturing excellence"
            fill
            sizes="(max-width: 768px) 320px, 512px"
            className="animate-float drop-shadow-2xl object-contain"
            priority={false}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
